// extracted by mini-css-extract-plugin
var _1 = "EntityProfileTabUpdatesCard-moduleavatar__ksof4";
var _2 = "EntityProfileTabUpdatesCard-modulecard__OoGK5";
var _3 = "EntityProfileTabUpdatesCard-modulecontent__ZtpqQ";
var _4 = "EntityProfileTabUpdatesCard-modulereadMoreButton__CUNlL";
var _5 = "EntityProfileTabUpdatesCard-moduletext__dn6fl";
export { _1 as "avatar", _2 as "card", _3 as "content", _4 as "readMoreButton", _5 as "text" }
